import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  IOffer,
  IOfferListRequest,
  IOfferCreateRequest,
  IOfferUpdateRequest,
  OfferState,
} from "@/types/offer";
import CustomRequest from "../customRequest";

const actions: ActionTree<OfferState, RootState> = {
  async get({ commit }, offer_id: number) {
    await CustomRequest.get<IOffer>({
      uri: `/offer/${offer_id}`,
      commit,
      target: "single",
    });
  },

  async getList({ commit }) {
    await CustomRequest.get<IPagination<IOffer>>({
      uri: `/offer`,
      commit,
      target: "pagination",
    });
  },

  async salesGet({ commit }, offer_id: number) {
    await CustomRequest.get<IOffer>({
      uri: `/sales/offer/${offer_id}`,
      commit,
      target: "single",
    });
  },

  async salesGetList({ commit }, params: IOfferListRequest) {
    await CustomRequest.get<IPagination<IOffer>>({
      uri: `/sales/offer/`,
      params,
      commit,
      target: "pagination",
    });
  },

  async salesUpdate(
    { commit },
    datas: { offer_id: number; params: IOfferUpdateRequest }
  ) {
    const { error } = await CustomRequest.patch<IOffer>({
      uri: `/sales/offer/${datas.offer_id}`,
      params: datas.params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async salesCreate({ commit }, params: IOfferCreateRequest) {
    const { error } = await CustomRequest.post<IOffer>({
      uri: `/sales/offer`,
      params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async salesDelete({ commit }, offer_id: number) {
    const { error } = await CustomRequest.delete({
      uri: `/sales/offer/${offer_id}`,
      flash: true,
    });

    return !error;
  },
};

export default actions;
